import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";
import { AuthStore } from "../../stores/auth-store";
import { App } from "../../stores/models/app";
import { Project, UserApp } from "../../stores/models/project";
import { ProjectAccess } from "../../stores/models/project-member";
import { ProjectStore } from "../../stores/project-store";
import { ProjectDashboardLayout, UIStore } from "../../stores/ui-store";
import { ProjectAppControl } from "./project-app-control";
import { ProjectDetails } from "./project-details";
import { ProjectEditor } from "./project-editor";
import { ProjectGridItem } from "./project-grid-item";
import { ProjectListItem } from "./project-list-item";

interface IProjectsViewProps{
	projects?: Project[];
	pinnedProjects?: Project[];
	uiStore?: UIStore;
	projectStore?: ProjectStore;
	statusFitlers?: string[];
}

interface IProjectsViewState{
	showEditor?: boolean;
	showAppControl?: boolean;
	showDetails?: boolean;
	selectedProject?: Project;
}

@inject("uiStore", "projectStore") @observer
export class ProjectsView extends React.Component<IProjectsViewProps, IProjectsViewState>
{
	constructor(props, state){
		super(props, state);

		this.state = {"showEditor": false, "showAppControl": false, "showDetails": false, "selectedProject": null};

		this.handleTogglePin = this.handleTogglePin.bind(this);
		this.handleEditProject = this.handleEditProject.bind(this);
		this.handleCloseProject = this.handleCloseProject.bind(this);
		this.handleShowAppControl = this.handleShowAppControl.bind(this);
		this.handleCloseAppControl = this.handleCloseAppControl.bind(this);
		this.handleShowDetails = this.handleShowDetails.bind(this);
		this.handleCloseDetails = this.handleCloseDetails.bind(this);
	}

	handleTogglePin(e, project: Project){
		e.preventDefault();
		e.stopPropagation();
		this.props.uiStore.toggleProjectPin(project.id);
		this.props.projectStore.loadPinnedProjects(this.props.uiStore.pinnedProjects.slice().map((pin) => pin));
	}

	async handleEditProject(e, project: Project){
		e.preventDefault();
		e.stopPropagation();
		this.setState({"showEditor": !this.state.showEditor, "selectedProject": project});
	}

	handleCloseProject(){
		this.setState({"showEditor": false});
	}

	handleShowAppControl(e, project: Project){
		e.preventDefault();
		e.stopPropagation();
		this.setState({"showAppControl": true, "selectedProject": project});
	}

	handleCloseAppControl(){
		this.setState({"showAppControl": false});
	}

	handleShowDetails(e, project: Project){
		e.preventDefault();
		e.stopPropagation();
		this.setState({"showDetails": true, "selectedProject": project});
	}

	handleCloseDetails(){
		this.setState({"showDetails": false});
	}

	render(){
		const { projects, pinnedProjects, uiStore } = this.props;
		let displayProjects = [];
		let displayPinnedProjects = [];

		if(this.props.statusFitlers && this.props.statusFitlers.length > 0){
			let filters = this.props.statusFitlers.map((filter) => {
				return filter.toLowerCase().replace(" ", "").trim();
			});
			displayProjects = _.filter(projects, (project) => {
				return _.indexOf(filters, project.status.toLowerCase().replace(" ", "").trim()) > -1 && pinnedProjects.map(pinProject => pinProject.id).indexOf(project.id) == -1;
			});
			displayPinnedProjects = _.filter(pinnedProjects, (project) => {
				return _.indexOf(filters, project.status.toLowerCase().replace(" ", "").trim()) > -1;
			});
		}
		else{
			displayProjects = projects.filter((project => pinnedProjects.map(pinProject => pinProject.id).indexOf(project.id) == -1));
			displayPinnedProjects = pinnedProjects;
		}

		return(
			<div>
				<ProjectEditor project={this.state.selectedProject} show={this.state.showEditor} onClose={this.handleCloseProject} />
				<ProjectAppControl project={this.state.selectedProject} show={this.state.showAppControl} onClose={this.handleCloseAppControl} />
				<ProjectDetails project={this.state.selectedProject} show={this.state.showDetails} onClose={this.handleCloseDetails} />
				<div style={{"marginTop": "60px", "marginLeft": "150px", "marginRight": "150px"}}>
				{uiStore.projectDashboardLayout == ProjectDashboardLayout.grid &&
					<div>
						<div className="ui three cards centered raised">
							{displayPinnedProjects.map((project: Project) => {
								return <ProjectGridItem demo={false} key={project.id} project={project} pinned={true} onEditProject={this.handleEditProject} onShowAppControl={this.handleShowAppControl} onTogglePin={this.handleTogglePin} onShowDetails={this.handleShowDetails} />;
							})}
						</div>
						{displayPinnedProjects.length > 0 &&
							<div className="ui section divider"></div>
						}
						<div className="ui three cards centered raised">
							{displayProjects.map((project: Project) => {
								return <ProjectGridItem demo={false} key={project.id} project={project} pinned={false} onEditProject={this.handleEditProject} onShowAppControl={this.handleShowAppControl} onTogglePin={this.handleTogglePin} onShowDetails={this.handleShowDetails} />;
							})}
						</div>
					</div>
				}
				{uiStore.projectDashboardLayout == ProjectDashboardLayout.list &&
					<div>
						<div className="ui big middle aligned divided selection list">
							{displayPinnedProjects.map((project: Project) => {
								return <ProjectListItem key={project.id} project={project} pinned={true} onEditProject={this.handleEditProject} onShowAppControl={this.handleShowAppControl} onTogglePin={this.handleTogglePin} onShowDetails={this.handleShowDetails} />;
							})}
						</div>
						{displayPinnedProjects.length > 0 &&
							<div className="ui section divider"></div>
						}
						<div className="ui big middle aligned divided selection list">
							{displayProjects.map((project: Project) => {
								return <ProjectListItem key={project.id} project={project} pinned={false} onEditProject={this.handleEditProject} onShowAppControl={this.handleShowAppControl} onTogglePin={this.handleTogglePin} onShowDetails={this.handleShowDetails} />;
							})}
						</div>
					</div>
				}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/projects/projects-view.tsx